import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";
import Inbox from "./Inbox";
import logo from "../../assets/svg/moves_offer_logo.svg";

const Header = () => {
  const { isAuthenticated, profile } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isAdmin = profile?.role?.toLowerCase() === "admin";

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 sm:gap-3 group flex-shrink min-w-0"
        >
          <div className="relative flex-shrink-0">
            <div className="absolute inset-0 bg-primary/10 rounded-full blur-sm group-hover:blur-md transition-all"></div>
            <img
              src={logo}
              alt="Moves Offer"
              className="h-12 w-12 sm:h-14 sm:w-14 relative z-10 rounded-full shadow-lg transform group-hover:scale-105 transition-transform duration-200"
            />
          </div>
          <span className="text-lg sm:text-xl md:text-2xl font-bold text-primary group-hover:text-primary-dark transition-colors whitespace-nowrap">
            Moves Offer
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700">
          {isAuthenticated && (
            <Link
              to="/create-order"
              className="hover:text-primary transition-colors"
            >
              Create Order
            </Link>
          )}
          <Link
            to="/calculator"
            className="hover:text-primary transition-colors"
          >
            Calculator
          </Link>

          {isAuthenticated && (
            <Link
              to="/auctions"
              className="hover:text-primary transition-colors"
            >
              Auctions
            </Link>
          )}

          <Link
            to={isAuthenticated ? "/profile" : "/signin"}
            className="hover:text-primary transition-colors"
          >
            {isAuthenticated ? "Profile" : "Sign In"}
          </Link>

          {isAdmin && (
            <Link
              to="/admin/dashboard"
              className="hover:text-primary transition-colors text-orange-600 font-semibold"
            >
              Admin Panel
            </Link>
          )}

          <div className="flex items-center gap-2">
            <Inbox />
          </div>
        </nav>

        {/* Mobile Menu Button + Inbox */}
        <div className="md:hidden flex items-center gap-1 flex-shrink-0">
          <Inbox />
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="flex flex-col gap-1.5 p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            <span
              className={`block w-6 h-0.5 bg-gray-700 transition-all ${mobileMenuOpen ? "rotate-45 translate-y-2" : ""}`}
            />
            <span
              className={`block w-6 h-0.5 bg-gray-700 transition-all ${mobileMenuOpen ? "opacity-0" : ""}`}
            />
            <span
              className={`block w-6 h-0.5 bg-gray-700 transition-all ${mobileMenuOpen ? "-rotate-45 -translate-y-2" : ""}`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${mobileMenuOpen ? "max-h-96" : "max-h-0"}`}
      >
        <nav className="flex flex-col space-y-4 px-6 py-4 bg-gray-50 border-t">
          <Link
            to="/create-order"
            className="text-gray-700 hover:text-primary transition-colors py-2"
            onClick={() => setMobileMenuOpen(false)}
          >
            Create Order
          </Link>
          <Link
            to="/calculator"
            className="text-gray-700 hover:text-primary transition-colors py-2"
            onClick={() => setMobileMenuOpen(false)}
          >
            Calculator
          </Link>

          {isAuthenticated && (
            <Link
              to="/auctions"
              className="text-gray-700 hover:text-primary transition-colors py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Auctions
            </Link>
          )}

          {isAdmin && (
            <Link
              to="/admin/dashboard"
              className="text-orange-600 hover:text-orange-700 font-semibold transition-colors py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Admin Panel
            </Link>
          )}

          <Link
            to={isAuthenticated ? "/profile" : "/signin"}
            className="text-gray-700 hover:text-primary transition-colors py-2"
            onClick={() => setMobileMenuOpen(false)}
          >
            {isAuthenticated ? "Profile" : "Sign In"}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
